import Web3 from 'web3'

async function loadWeb3() {
  if (window.ethereum) {
    window.web3 = new Web3(window.ethereum)
    await window.ethereum.enable()
  }
  else if (window.web3) {
    window.web3 = new Web3(window.web3.currentProvider)
  }
  else {
    window.alert('Non-Ethereum browser detected. You should consider trying MetaMask!')
  }
}


function getParam() {
  const url = window.location.search; //获取url中"?"符后的字串
  let theRequest = new Object();
  if (url.indexOf("?") != -1) {
     let str = url.substr(1);
     let strs = str.split("&");
     for(let i = 0; i < strs.length; i ++) {
        theRequest[strs[i].split("=")[0]]=unescape(strs[i].split("=")[1]);
     }
  }
  return theRequest;
}

function toFix6(num) {
  return num === 0 ? '0.000000' :  (num / 1e6).toFixed(6);
}

function mutiple6(num) {
  return num * 1e6;
}

// ctx 是一个 Vue 上下文
function confirmingTransaction(ctx, hash) {
  ctx.$store.commit('setConfirming', true);
  ctx.$store.commit('setTrx', hash);
  ctx.$store.commit('unshiftTrxData', {
    id: hash,
    status: 'loading'
  })
  // 两秒后结束
  setTimeout(function() {
    ctx.$store.commit('setConfirming', false);
  }, 2000);
}

// 2秒更新一次全局数据
function updateGlobalData(hstContract, commit, state) {
  setInterval(function() {
    hstContract.methods.global_(0).call()
      .then(res => {
        commit('setAccountStatus', {
          totalOut: toFix6( res.total_out ),
          totalStake: toFix6( res.total_stake )
        })
      });
    const promise1 = hstContract.methods.plyr_(state.myAddress).call();
    const promise2 = hstContract.methods.cal_out(state.myAddress).call();
    const status = {};
    Promise.all([promise1, promise2]).then(res => {
      status.stakedToken = toFix6(res[0].stake);
      status.withdrawDivide = toFix6(res[0].total_out);
      status.stillCanWithdrawDivide = toFix6(res[1]);
      commit('setAccountStatus', status);
      if(state.loadingData === true) {
        commit('setConfirming', false);
        commit('setLoadingData', false);
      }
    });
  }, 5000);
}

export  { loadWeb3, getParam, toFix6, mutiple6, confirmingTransaction, updateGlobalData }
